import styles from './Projects.module.css';
import { useEffect } from 'react';
import { useState } from 'react';

import './projects-animations.css';

import { animations, removeAnimation } from '../../scripts/animations';

import paths from '../../config/paths';

import ProjectsSVG from '../../components/SVG/Projects/Projects'
import Pot from '../../components/SVG/Projects/Pot';
import Plant1 from "../../components/SVG/Projects/Plant1";
import Plant2 from "../../components/SVG/Projects/Plant2";
import Plant3 from "../../components/SVG/Projects/Plant3";
import ProjectCard from "../../components/Projects/ProjectCard";

import quaiAntique_img from '../../images/projects/quai_antique.png'
import désAventures_img from '../../images/projects/dés-aventures.png';
import rollinBattle_img from '../../images/projects/Rollin_battle.png'
import memory_img from '../../images/projects/memory.png';
import charlesCantin_img from '../../images/projects/charles_cantin.png'
import pony_img from '../../images/projects/pony.png'
import codepen_img from '../../images/projects/codepen.jpg'

import charlesCantin_mp4 from '../../video/charles_cantin.mp4'
import charlesCantin_webm from '../../video/charles_cantin.webm'
import quaiAntique_mp4 from '../../video/quai_antique.mp4'
import quaiAntique_webm from '../../video/quai_antique.webm'

const changeLowOpacity = (...elements) => {
    for (let element of elements) {
        element.style.opacity = 0;
    }
}
const changeUpOpacity = (...elements) => {
    for (let element of elements) {
        element.style.opacity = 1;
    }
}


export default function Projects({ visited }) {
    const [cardOpen, setCardOpen] = useState(false);

    const handlePlantClick = e => {

        if (cardOpen) {
            return
        } else {
            setCardOpen(true);
        }
        
        const parentElement = e.target.closest('.parentElement');
        const front = parentElement.querySelector('.front');
        const back = parentElement.querySelector(".back");

        if (parentElement.classList.contains('appeard')) {
            parentElement.classList.remove("appeard");
        }
        if (parentElement.classList.contains('firstCard')) {
            parentElement.classList.remove('firstCard');
        }
        setTimeout(() => {
            parentElement.style.transform = "rotateY(-180deg)";
        }, 100);
        
        setTimeout(() => {
            changeLowOpacity(front, back)
            setTimeout(() => {
                parentElement.style.opacity = 0;
                parentElement.classList.add('projectBig');
                setTimeout(() => {
                    parentElement.style.opacity = 1;
                    setTimeout(() => {
                        back.style.opacity = 1;
                    }, 500);
                }, 100);
            }, 500);
        }, 1000);
        
    }

    const handleCloseCard = () => {
        setCardOpen(false);

        const parentElement = document.querySelector('.projectBig');
        const front = parentElement.querySelector('.front')
        const back = parentElement.querySelector('.back')

        back.style.opacity = 0;

        const video = parentElement.querySelector('video');
        if (video) {
            video.pause()
        }

        setTimeout(() => {
            back.style.opacity = 0; 
            
            setTimeout(() => {
                parentElement.opacity = 0;
                parentElement.classList.remove("projectBig");
                
                if (video) {
                    video.currentTime = 0
                }

                changeUpOpacity(front, back);
                setTimeout(() => {
                    parentElement.opacity = 1;
                    parentElement.style.transform = "";
                }, 500);
            }, 500);
        }, 500);

    }

    useEffect(() => {
        if (!visited) {
            animations(1200, ".group-projects");
        } else {
            removeAnimation('.group-projects')
        }
    })
    // useEffect(() => {
    //     const firstCard = document.querySelector("#firstCard")

    //     setTimeout(() => {
    //         firstCard.classList.replace('appeard', 'firstCard');
    //     }, 3000);
    // }, [])

    const handleMainClick = e => {
        if (!cardOpen) {
            return;
        }
        const cardSelected =  document.querySelector(".projectBig .back")
        if (!cardSelected.contains(e.target)) {
            handleCloseCard();
        }
        return;
    }

    const handleResize = () => {
        const carousel = document.querySelector('#projects');
        const active = document.querySelector('.card-active');
        const projectWidth = active.clientWidth;

        let index = 0;
        for (let children of carousel.children) {
            if (active === children) {
                break;
            } 
            index--;
        }

        carousel.style.transform = `translateX(${projectWidth * index}px)`;
    }

    window.addEventListener('resize', handleResize);

    const moveCarouselLeft = () => {
        const carousel = document.querySelector('#projects');
        const project = document.querySelector('.card-active');
        const projectWidth = project.clientWidth;
        let nextActive;
        if (project.previousElementSibling) {
            nextActive = project.previousElementSibling;
        } else {
            nextActive = carousel.lastChild;
        }
        nextActive.classList.add('card-active');
        project.classList.remove('card-active');

        let index = 0;
        for (let children of carousel.children) {
            if (nextActive === children) {
                break;
            } 
            index--;
        }

        carousel.style.transform = `translateX(${projectWidth * index}px)`;
    }
    const moveCarouselRight = () => {
        const carousel = document.querySelector('#projects');
        const project = carousel.querySelector('.card-active');
        let nextActive;
        if (project.nextElementSibling) {
            nextActive = project.nextElementSibling;
        } else {
            nextActive = carousel.firstChild;
        }
        nextActive.classList.add('card-active');
        project.classList.remove('card-active');

        let index = 0;
        for (let children of carousel.children) {
            if (nextActive === children) {
                break;
            } 
            index++;
        }

        const projectWidth = project.clientWidth;
        carousel.style.transform = `translateX(-${projectWidth * index}px)`;
    }
    return (
        <main className='relative' onClick={handleMainClick}>
            <ProjectsSVG visited={visited}></ProjectsSVG>
            <section className="text-section w-full pb-8">
                <h1 className='title group-projects toScale'>Projets</h1>
                <p className='text-center text-900 font-medium group-projects hide'>N'hésitez pas à cliquer sur les différentes cartes pour voir les détails !</p>
                <div className={`${styles.projectsAbout} group-projects hide`}>
                    <div className={`${styles.carouselProjects} carousel`}>
                        <div className={styles.arrowsContainer}>
                            <button className={`${styles.arrow}`} onClick={moveCarouselLeft}><i className="fa-solid fa-caret-left"></i></button>
                            <button className={`${styles.arrow}`} onClick={moveCarouselRight}><i className="fa-solid fa-caret-right"></i></button>
                        </div>
                        <div className={styles.projects} id="projects">
                            <div className={`card-active ${styles.cardContainer}`}>
                                <ProjectCard
                                    img={quaiAntique_img}
                                    title="Quai Antique"
                                    url={paths.QUAI_ANTIQUE}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={charlesCantin_img}
                                    title="Charles Cantin"
                                    url={paths.CHARLES_CANTIN}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={désAventures_img}
                                    title="Dés Aventures"
                                    url={paths.DES_AVENTURES}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={rollinBattle_img}
                                    title="Rollin' Battle"
                                    url={paths.ROLLIN_BATTLE}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={memory_img}
                                    title="Memory"
                                    url={paths.MEMORY}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={pony_img}
                                    title="My Little Pony"
                                    url={paths.MLP}
                                    ></ProjectCard>
                            </div>
                            <div className={styles.cardContainer}>
                                <ProjectCard
                                    img={codepen_img}
                                    title="Codepen"
                                    url={paths.CODEPEN}
                                    ></ProjectCard>
                            </div>
                        </div>
                    </div>
                    <div className={styles.Pot}>
                        <Pot></Pot>
                    </div>
                </div>
            </section>
        </main>
    )
}


{/* <div className={`${styles.projectContainer} parentElement group-projects hide`} onClick={handlePlantClick} id="firstCard">
                        <button className={`${styles.projectFront} front`} aria-label='Voir le projet Charles Cantin' >
                            <Plant1></Plant1>
                        </button>
                        <div className={`${styles.projectBack} back`}>
                            <ProjectCard title="Charles Cantin" 
                                        handleCard={handleCloseCard}
                                        videoMp4={charlesCantin_mp4}
                                        videoWebm={charlesCantin_webm}
                                        link="https://charles-cantin-photography.netlify.app/"
                                        content="Evaluation demandant d'utiliser un CMS Headless (ici le CMS de Netlify) permettant la modification du site."
                                        skills="HTML/CSS | Javascript | React"></ProjectCard>
                        </div>
                    </div>
                    <div className={`${styles.projectContainer} parentElement group-projects hide`} onClick={handlePlantClick}>
                        <button className={`${styles.projectFront} front`} aria-label="Voir le projet Quai Antique">
                            <Plant2></Plant2>
                        </button>
                        <div className={`${styles.projectBack} back`}>
                            <ProjectCard title="Quai Antique" 
                                        handleCard={handleCloseCard}
                                        videoMp4={quaiAntique_mp4}
                                        videoWebm={quaiAntique_webm}
                                        link="https://quai-antique.fr/"
                                        content="ECF final avec une partie admin que j'ai faite entièrement qui permet de modifier le site et de voir les réservations."
                                        skills="HTML/CSS | Tailwind | Javascript | PHP | SQL | Symfony"></ProjectCard>
                        </div>
                    </div>
                    <div className={`${styles.projectContainer} parentElement group-projects hide`} onClick={handlePlantClick}>
                        <button className={`${styles.projectFront} front`} aria-label="Voir le projet Dés Aventures">
                            <Plant3></Plant3>
                        </button>
                        <div className={`${styles.projectBack} back`}>
                            <ProjectCard title="Dés Aventures" 
                                        handleCard={handleCloseCard}
                                        img={désAventures}
                                        link="https://des-aventures.netlify.app/"
                                        content="Dés Aventures est un des premiers projets que j'ai fait. Il fallait faire un site vitrine pour une association." 
                                        skills="HTML/CSS | Bootstrap | Javascript"></ProjectCard>
                        </div>
                    </div> */}